import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable, catchError, of} from "rxjs";
import { Agenda } from '../../customs/_models/AgendaDTO';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AgendaService {
  private apiUrl = `${environment.base_url}/api/agendas`;

  constructor(private http: HttpClient) {}

  getAgendas(): Observable<Agenda[]> {
    return this.http.get<Agenda[]>(this.apiUrl);
  }

  getAgendaById(id: number): Observable<Agenda> {
    return this.http.get<Agenda>(`${this.apiUrl}/${id}`);
  }

  createAgenda(agenda: Agenda): Observable<Agenda> {
    return this.http.post<Agenda>(this.apiUrl, agenda);
  }

  deleteAgenda(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}